import React from 'react';

import LinearGradient from 'react-native-linear-gradient';

import { isTablet, isTabletOrWeb } from 'utils/responsiveness';

import { verticalGradient } from 'components/Gallery/сomponents/Gradient';

import styles, {
    phoneBottomColors,
    phoneBottomLocations,
    tabletAngleCenter,
    tabletBottomColors,
    tabletBottomLocations,
    tabletLeftColors,
    tabletLeftLocations,
    tabletLeftStart,
} from './styles';

function DetailImageGradient() {
    if (isTabletOrWeb) {
        return (
            <>
                {!isTablet && (
                    <LinearGradient
                        style={styles.top}
                        start={verticalGradient.translucent}
                        end={verticalGradient.opaque}
                        locations={verticalGradient.locations}
                        colors={verticalGradient.colors}
                        pointerEvents="none"
                    />
                )}
                <LinearGradient
                    style={styles.left}
                    start={tabletLeftStart}
                    angle={90}
                    angleCenter={tabletAngleCenter}
                    colors={tabletLeftColors}
                    locations={tabletLeftLocations}
                    useAngle
                />
                <LinearGradient
                    style={styles.bottom}
                    colors={tabletBottomColors}
                    locations={tabletBottomLocations}
                />
            </>
        );
    }

    return (
        <LinearGradient
            style={styles.root}
            colors={phoneBottomColors}
            locations={phoneBottomLocations}
        />
    );
}

export default DetailImageGradient;
